import { ref, onMounted, onUnmounted } from "vue";
import { deviceQRScanDecode, gatewayLabelDecode } from "../helpers/devices";

let accumulateStr = "";
const $scannedDevice = ref(null);
const $scannedGateway = ref(null);
const $scanError = ref(null);

const alphaNumReg = /^[a-zA-Z0-9 \-:.]$/;
function processKeypress(/** @type {KeyboardEvent} */ event) {
  //skip all inner elements events except .qr-scan
  if (
    (event.target.tagName !== "BODY" &&
      !event.target.classList.contains("qr-scan")) ||
    event.altKey ||
    event.ctrlKey
  )
    return;

  if (alphaNumReg.test(event.key)) {
    event.stopPropagation();
    event.preventDefault();
    accumulateStr += event.key;
    return false;
  }
  switch (event.key) {
    case "Shift":
      //do nothing
      break;
    case "Enter":
      event.stopPropagation();
      event.preventDefault();
      tryDecodeDevice(accumulateStr);
      accumulateStr = "";
      break;

    default:
      accumulateStr = "";
  }
}

function tryDecodeDevice(str, isDataMatrixFormat = false) {
  // console.debug(str);
  let decoded = null;
  try {
    decoded = isDataMatrixFormat
      ? gatewayLabelDecode(str)
      : deviceQRScanDecode(str);
    $scanError.value = null;
  } catch (errorMessage) {
    $scanError.value = errorMessage;
    console.log(errorMessage);
  }
  // console.log("decoded", decoded);

  if (isDataMatrixFormat) {
    if (decoded === true) {
      return "partial";
    }
    $scannedGateway.value = decoded;
    return decoded ? "gateway" : null;
  }

  $scannedDevice.value = decoded;
  return decoded ? "device" : null;
}

const $listeningForQRScan = ref(null);
function windowFocused() {
  $listeningForQRScan.value = "active";
}
function windowBlurred() {
  $listeningForQRScan.value = "passive";
}

export default function useQRScanner(attachEvents = true) {
  if (attachEvents) {
    onMounted(() => {
      document.addEventListener("keydown", processKeypress);
      window.addEventListener("blur", windowBlurred);
      window.addEventListener("focus", windowFocused);
      $listeningForQRScan.value = document.hasFocus() ? "active" : "passive";
    });
    onUnmounted(() => {
      document.removeEventListener("keydown", processKeypress);
      window.removeEventListener("blur", windowBlurred);
      window.removeEventListener("focus", windowFocused);
      $listeningForQRScan.value = null;
    });
  }
  return {
    $scannedDevice,
    $scannedGateway,
    $scanError,
    $listeningForQRScan,
    tryDecodeDevice,
    resetScannedDevice: () => ($scannedDevice.value = null),
  };
}
